import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import UnstyledButton from '@kiosk/common/components/ui/UnstyledButton';
import ContentText from '@kiosk/common/components/Text/ContentText';
import { ViewTasksContainer } from '@kiosk/common/components/UserPanel/ViewTasksLink/viewTasksLink.styles';

type Props = { delay: number; onClick: VoidFunction };

const ViewTasksLink = ({ delay, onClick }: Props) => (
  <ViewTasksContainer delay={delay}>
    <UnstyledButton onClick={onClick}>
      <ContentText themeColor={ThemeColorType.primary} bold fontSize="14px">
        View tasks &gt;
      </ContentText>
    </UnstyledButton>
  </ViewTasksContainer>
);

export default ViewTasksLink;
